/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AuthRequestBuilderNavigationMetadata, type AuthRequestBuilder } from './auth/index.js';
// @ts-ignore
import { BillingRequestBuilderNavigationMetadata, type BillingRequestBuilder } from './billing/index.js';
// @ts-ignore
import { DirectoriesRequestBuilderNavigationMetadata, DirectoriesRequestBuilderRequestsMetadata, type DirectoriesRequestBuilder } from './directories/index.js';
// @ts-ignore
import { FilesRequestBuilderNavigationMetadata, FilesRequestBuilderRequestsMetadata, type FilesRequestBuilder } from './files/index.js';
// @ts-ignore
import { HealthRequestBuilderRequestsMetadata, type HealthRequestBuilder } from './health/index.js';
// @ts-ignore
import { ImageWatermarkPresetsRequestBuilderNavigationMetadata, ImageWatermarkPresetsRequestBuilderRequestsMetadata, type ImageWatermarkPresetsRequestBuilder } from './imageWatermarkPresets/index.js';
// @ts-ignore
import { ImageWatermarksRequestBuilderNavigationMetadata, ImageWatermarksRequestBuilderRequestsMetadata, type ImageWatermarksRequestBuilder } from './imageWatermarks/index.js';
// @ts-ignore
import { JobsRequestBuilderNavigationMetadata, JobsRequestBuilderRequestsMetadata, type JobsRequestBuilder } from './jobs/index.js';
// @ts-ignore
import { NotificationsRequestBuilderNavigationMetadata, NotificationsRequestBuilderRequestsMetadata, type NotificationsRequestBuilder } from './notifications/index.js';
// @ts-ignore
import { SearchRequestBuilderNavigationMetadata, type SearchRequestBuilder } from './search/index.js';
// @ts-ignore
import { SettingsRequestBuilderNavigationMetadata, type SettingsRequestBuilder } from './settings/index.js';
// @ts-ignore
import { SharesRequestBuilderNavigationMetadata, type SharesRequestBuilder } from './shares/index.js';
// @ts-ignore
import { TagsRequestBuilderNavigationMetadata, TagsRequestBuilderRequestsMetadata, type TagsRequestBuilder } from './tags/index.js';
// @ts-ignore
import { TrashRequestBuilderRequestsMetadata, type TrashRequestBuilder } from './trash/index.js';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type RequestAdapter } from '@microsoft/kiota-abstractions';
// @ts-ignore
import { FormParseNodeFactory, FormSerializationWriterFactory } from '@microsoft/kiota-serialization-form';
// @ts-ignore
import { JsonParseNodeFactory, JsonSerializationWriterFactory } from '@microsoft/kiota-serialization-json';
// @ts-ignore
import { MultipartSerializationWriterFactory } from '@microsoft/kiota-serialization-multipart';
// @ts-ignore
import { TextParseNodeFactory, TextSerializationWriterFactory } from '@microsoft/kiota-serialization-text';

/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface ContentVaultApiClient extends BaseRequestBuilder<ContentVaultApiClient> {
    /**
     * The auth property
     */
    get auth(): AuthRequestBuilder;
    /**
     * The billing property
     */
    get billing(): BillingRequestBuilder;
    /**
     * The directories property
     */
    get directories(): DirectoriesRequestBuilder;
    /**
     * The files property
     */
    get files(): FilesRequestBuilder;
    /**
     * The health property
     */
    get health(): HealthRequestBuilder;
    /**
     * The imageWatermarkPresets property
     */
    get imageWatermarkPresets(): ImageWatermarkPresetsRequestBuilder;
    /**
     * The imageWatermarks property
     */
    get imageWatermarks(): ImageWatermarksRequestBuilder;
    /**
     * The jobs property
     */
    get jobs(): JobsRequestBuilder;
    /**
     * The notifications property
     */
    get notifications(): NotificationsRequestBuilder;
    /**
     * The search property
     */
    get search(): SearchRequestBuilder;
    /**
     * The settings property
     */
    get settings(): SettingsRequestBuilder;
    /**
     * The shares property
     */
    get shares(): SharesRequestBuilder;
    /**
     * The tags property
     */
    get tags(): TagsRequestBuilder;
    /**
     * The trash property
     */
    get trash(): TrashRequestBuilder;
}
/**
 * Instantiates a new {@link ContentVaultApiClient} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createContentVaultApiClient(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    const serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry;
    const parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry;
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    
    if (parseNodeFactoryRegistry.registerDefaultDeserializer) {
        parseNodeFactoryRegistry.registerDefaultDeserializer(JsonParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(TextParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(FormParseNodeFactory, backingStoreFactory);
    }
    
    if (serializationWriterFactory.registerDefaultSerializer) {
        serializationWriterFactory.registerDefaultSerializer(JsonSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(TextSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(FormSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(MultipartSerializationWriterFactory);
    }
    
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<ContentVaultApiClient>(requestAdapter, pathParameters, ContentVaultApiClientNavigationMetadata, undefined);
}
/**
 * Uri template for the request builder.
 */
export const ContentVaultApiClientUriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ContentVaultApiClientNavigationMetadata: Record<Exclude<keyof ContentVaultApiClient, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    auth: {
        navigationMetadata: AuthRequestBuilderNavigationMetadata,
    },
    billing: {
        navigationMetadata: BillingRequestBuilderNavigationMetadata,
    },
    directories: {
        requestsMetadata: DirectoriesRequestBuilderRequestsMetadata,
        navigationMetadata: DirectoriesRequestBuilderNavigationMetadata,
    },
    files: {
        requestsMetadata: FilesRequestBuilderRequestsMetadata,
        navigationMetadata: FilesRequestBuilderNavigationMetadata,
    },
    health: {
        requestsMetadata: HealthRequestBuilderRequestsMetadata,
    },
    imageWatermarkPresets: {
        requestsMetadata: ImageWatermarkPresetsRequestBuilderRequestsMetadata,
        navigationMetadata: ImageWatermarkPresetsRequestBuilderNavigationMetadata,
    },
    imageWatermarks: {
        requestsMetadata: ImageWatermarksRequestBuilderRequestsMetadata,
        navigationMetadata: ImageWatermarksRequestBuilderNavigationMetadata,
    },
    jobs: {
        requestsMetadata: JobsRequestBuilderRequestsMetadata,
        navigationMetadata: JobsRequestBuilderNavigationMetadata,
    },
    notifications: {
        requestsMetadata: NotificationsRequestBuilderRequestsMetadata,
        navigationMetadata: NotificationsRequestBuilderNavigationMetadata,
    },
    search: {
        navigationMetadata: SearchRequestBuilderNavigationMetadata,
    },
    settings: {
        navigationMetadata: SettingsRequestBuilderNavigationMetadata,
    },
    shares: {
        navigationMetadata: SharesRequestBuilderNavigationMetadata,
    },
    tags: {
        requestsMetadata: TagsRequestBuilderRequestsMetadata,
        navigationMetadata: TagsRequestBuilderNavigationMetadata,
    },
    trash: {
        requestsMetadata: TrashRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
